import { FilteredCreditApplication } from '@applyonline/shared'
import { B2C_MERCHANT_IDS, CIRCLEK_BRAND_ID, CIRCLEK_CAMPAIN_ID, Constants, MARCS_BRAND_ID } from '../../types'
import { useMerchantIdFromSubdomain } from '../ApplicationForm/hooks'

export const useMerchantLogo = () => {
  const merchantId = useMerchantIdFromSubdomain()

  const getLogoUrl = () => {
    switch (merchantId) {
      case B2C_MERCHANT_IDS.neo:
        return 'https://icebergstatic.blob.core.windows.net/b2c-merchant-logos/24584.png'
      default:
        return '/logo.svg'
    }
  }

  return {
    logoUrl: getLogoUrl(),
    merchantId,
  }
}

export const useMerchantLogoWithiFinancePartnership = (lang: string, creditApplication: FilteredCreditApplication) => {
  const getLogoUrl = () => {
    switch (creditApplication.merchantId) {
      case B2C_MERCHANT_IDS.neo:
        return `https://icebergstatic.blob.core.windows.net/b2c-merchant-logos/part_24584_${lang}.png`
      default: {
        const isMarcsCampaign =
          creditApplication.lastTouchOrigination?.campaignId === CIRCLEK_CAMPAIN_ID &&
          creditApplication.lastTouchOrigination?.brandId === MARCS_BRAND_ID

        const partnerId = isMarcsCampaign
          ? `${CIRCLEK_CAMPAIN_ID}-${MARCS_BRAND_ID}`
          : `${CIRCLEK_CAMPAIN_ID}-${CIRCLEK_BRAND_ID}`
        return `https://icebergstatic.blob.core.windows.net/b2c-merchant-logos/${partnerId}_partn_${lang}.png`
      }
    }
  }

  return getLogoUrl()
}

export const useMerchantLogoLinkDestination = () => {
  const merchantId = useMerchantIdFromSubdomain()
  switch (merchantId) {
    case B2C_MERCHANT_IDS.neo:
      return `${Constants.Host.Ifinance}/neo-partnership/`
    default:
      return Constants.Host.Ifinance
  }
}
